import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigService } from './config.service';

@Injectable()
export class GemstoneService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  private baseUrl(): string {
    return `${this.configService.apiUrl()}/gemstone`;
  }

  checkWebId(webId: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/checkWebId`;
    return this.http.post(REST_URL, { webId }, this.httpOptions);
  }

  createAndCommitRestructureInstruction(documentId: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/createAndCommitRestructureInstruction`;
    return this.http.post(REST_URL, { documentId }, this.httpOptions);
  }

  getOnlineInvestorList(webId: string, role: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/getOnlineInvestorList`;
    return this.http.post(REST_URL, { webId, role }, this.httpOptions);
  }

  getFeeWithdrawal(feeWithdrawalOop: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/getFeeWithdrawalForOopId`;
    return this.http.get(`${REST_URL}?feeWithdrawalOop=${feeWithdrawalOop}`);
  }
}
